export const formatDate = (dateStr) =>{
    // const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
    //                 "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dateObj = new Date(dateStr + "Z");
    const day = String(dateObj.getDate()).padStart(2, '0');
    //const month = months[dateObj.getMonth()];
    // add +1 to month as getMonth() returns 0-11
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
  
    return `${day}.${month}.${year}`;
  }
  